export default __webpack_public_path__ + "static/media/notavailable4.cb5577b3.jpg";